import React, { createContext, useState, useEffect, useCallback, useMemo } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiFetch = useCallback(async (input, init) => {
    return await fetch(input, init);
  }, []);

  const contextValue = useMemo(
    () => ({ config, setConfig, apiFetch }),
    [config, apiFetch]
  );

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await fetch("/config.json");
        if (!response.ok) {
          throw new Error("Failed to load config.json");
        }
        const data = await response.json();
        setConfig(data);
      } catch (err) {
        console.error("Error loading config:", err);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};
